import { createAsyncThunk } from "@reduxjs/toolkit";
import { setCommitmentsRecommendationsFilters } from "@/store/commitments/commitmentsSlice";
import { getCommitmentsRecommendationsThunk } from "@/store/commitments/thunks/recommendations/getCommitmentsRecommendationsThunk";
import { setRecommendationsInitialFiltersThunk } from "@/store/commitments/thunks/recommendations/setRecommendationsInitialFiltersThunk";
import { getRecommendationFiltersUserPreferenceByKeyThunk } from "@/store/commitments/thunks/recommendations/user-preference/getRecommendationFiltersUserPreferenceByKeyThunk";
import { recommendationsDefaultFilters } from "@/store/commitments/utils/constants";

export const initiateSavingPlansRecommendationsThunk = createAsyncThunk(
  "commitments/initiateSavingPlansRecommendationsThunk",
  async (_: void, { dispatch }) => {
    dispatch(
      setCommitmentsRecommendationsFilters(recommendationsDefaultFilters),
    );

    await dispatch(
      getRecommendationFiltersUserPreferenceByKeyThunk("savings_plan"),
    );
    await dispatch(setRecommendationsInitialFiltersThunk("savings_plan"));
    dispatch(getCommitmentsRecommendationsThunk());
  },
);
